import Pie from './Pie'
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { messagesApi } from '../../../../utils'
import { ObjectTypeEnumText } from '../../../../models/ObjectTypeEnum'
import Moment from 'moment';
import classes from './MessageArea.module.css'
import * as SubmissionStatus from '../../../../models/SubmissionStatus'
import { throwApiError } from '../../../lms-shared/store/error-handling-actions';
import { useNavigate } from 'react-router-dom';
import { onKeyDown } from '../../../../service';

const MessageArea = ({ setShowMessagesPopup, showMessagesPopup, setShowQuickApproachPopup, studyGroupId }) => {
    const { direction, lang, texts } = useSelector(state => state.translate);
    const uiData = useSelector((state) => state.general.uiData);
    const { homeUrl } = useSelector(state => state.application);
    const [messages, setMessages] = useState([])
    // const messages = useSelector(state => state.messages.messages);

    const [percentagSubmittedAssignments, setPercentagSubmittedAssignments] = useState(0)
    const ToCData = useSelector(state => state.topics.topics);
    const dispatch = useDispatch()
    const navigate = useNavigate()

    useEffect(() => {
        if (uiData) {
            async function getMessages() {
                const data = {
                    refObjectId: studyGroupId,
                    refObjectType: ObjectTypeEnumText.StudyGroup,
                    targetObjects: [
                        { type: ObjectTypeEnumText.User },
                    ],
                    lang: lang,
                    ignoreMessageTypesIds: [uiData.bannerMessageTypeId]
                }
                messagesApi.messagesFilterRangePost({ messagesRangeFilter: data }, (error, resdata, response) => {
                    if (error) {
                        dispatch(throwApiError({ userMessage: texts.MessageContentMessagesFilterRange, error: error, statusCode: response?.statusCode, message: "messagesFilterRangePost " + error.message, level: 1, component: "MessageArea", line: 34 }))
                    } else {
                        resdata.sort((a, b) => new Date(b.sentDate) - new Date(a.sentDate))

                        setMessages(resdata.slice(0, 3).map(m => {
                            // parse contents message to dict with lang keys
                            const parsecontents = m.contents?.reduce((obj, c) => { obj[c.lang] = c.content && JSON.parse(c.content); return obj }, {});
                            m.contents = parsecontents ?? {};
                            return m;
                        }))

                        // resdata.length > 3 ? setMessages([resdata[0], resdata[1], resdata[2]]) : setMessages(resdata)
                    }
                })
            }
            if (lang)
                getMessages()
        }
    }, [lang, uiData])

    useEffect(() => {
        getPercentageOfAssignmentsSubmitted(ToCData)
    }, [ToCData])

    function getPercentageOfAssignmentsSubmitted(ToCData) {
        let numAssesments = 0
        let submittedAssessments = 0
        function getAverege(child, index) {
            if (child?.assessments) {
                child.assessments.forEach(assessment => {
                    if (assessment.activityType === "Final") {
                        numAssesments++;
                        if (
                            assessment.submission &&
                            [SubmissionStatus.completed, SubmissionStatus.scored, SubmissionStatus.resubmitted, SubmissionStatus.submitted].includes(assessment.submission.submissionStatus)
                        ) {
                            submittedAssessments++;
                        }
                    }
                });
            }
            else {
                if (child.children) {
                    child.children.map(l => { getAverege(l, index) })
                }
            }
        }
        ToCData && ToCData.map((y, index) => getAverege(y, index))
        let percentegeNum = (numAssesments > 0 ? (submittedAssessments / numAssesments) * 100 : 0)
        setPercentagSubmittedAssignments(Math.round(percentegeNum * 10) / 10)
    }

    function ShowMessagesPopup(e) {
        e.stopPropagation();
        setShowQuickApproachPopup(false)
        setShowMessagesPopup((showMessagesPopup) => !showMessagesPopup)
    }

    const getRightDate = (date) => {
        const returnDate = Moment(date).format('DD/MM')
        const today = Moment(new Date()).format('DD/MM')
        return returnDate === today ? texts.today : returnDate
    }

    const messageItemOnClick = (m) => {
        const messageContent = m.contents[lang]
        const data = {
            messagesIds: [m.id]
        }
        messagesApi.messagesSetReadRangePost({ messageSetReadRangeInput: data }, (error, resdata, response) => {
            if (error) {
                dispatch(throwApiError({ userMessage: texts.MessageContentMessagesSetReadRange, error: error, statusCode: response?.statusCode, message: "messagesSetReadRangePost " + error.message, level: 1, component: "MessageArea", line: 88 }))
            }
        })
        if (messageContent.link) {
            if (messageContent.link.startsWith('http'))
                window.location.href = messageContent.link
            else navigate(`${homeUrl}/${messageContent.link}`)
        }
    }

    return (<>
        {!showMessagesPopup && <div 
        className={`${classes[direction]} ${classes.MsgTab}`} 
        onClick={(e) => ShowMessagesPopup(e)} 
        tabIndex="0" 
        role="button" 
        onKeyDown={e => onKeyDown(e, () => ShowMessagesPopup(e))}>
            <div className={classes.TabText}>{texts.statusAndMessages}</div>
            <div className={classes.PopupIcon}></div>
        </div>}
        <div className={`${direction === 'ltr' ? classes.LtrMsgContainer : ''} ${classes.MsgContainer} ${showMessagesPopup ? classes.OpenMsgPopup : classes.CloseMsgPopup}`}>
            <div className={classes.MessageArea}>
                <div className={classes.PopupName}>
                    <div className={classes.TabText}>{texts.statusAndMessages}</div>
                    <div className={classes.PopupIcon}></div>
                </div>

                <div className={classes.ProgressBar}>
                    <Pie val={percentagSubmittedAssignments} color={"#FEF652"} />
                </div>
                <div className={classes.Messages}>
                    {messages && messages.length > 0 ? messages.map((m, i) =>
                        <div key={`message_${i}`} className={classes.MessageItem} onClick={() => messageItemOnClick(m)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => messageItemOnClick(m))}>
                            {!m.isRead && <div className={classes.RedMark}></div>}
                            <div className={classes.Message}>
                                {m.contents && <div className={classes.MessageText}>{m.contents[lang]?.text}</div>}
                            </div>
                            <div className={classes.MessageDate}>{getRightDate(m.sentDate)}</div>
                        </div>
                    ) :
                        <div className={classes.NoMessages}>{texts.noMessages}</div>}
                </div>
            </div>
        </div>
    </>)
}

export default MessageArea;